<template>
  <b-sidebar
    id="add-new-customer-sidebar"
    :visible="isAddNewCustomerSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-customer-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('AppCustomer.newCustomer') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Alias-->
          <validation-provider
            #default="validationContext"
            :name="$t('AppCustomer.columns.nickname')"
            rules="required|max:10"
          >
            <b-form-group
              :label="$t('AppCustomer.columns.nickname')"
              label-for="alias"
            >
              <b-form-input
                id="alias"
                v-model="customerData.alias"
                autofocus
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Nombre -->
          <validation-provider
            #default="validationContext"
            :name="$t('AppCustomer.columns.name')"
            rules="required|max:150"
          >
            <b-form-group
              :label="$t('AppCustomer.columns.name')"
              label-for="nombre"
            >
              <b-form-input
                id="nombre"
                v-model="customerData.nombre"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- RFC -->
          <validation-provider
            #default="validationContext"
            :name="$t('AppCustomer.columns.rfc')"
            rules="required|max:13|min:12"
          >
            <b-form-group
              :label="$t('AppCustomer.columns.rfc')"
              label-for="rfc"
            >
              <b-form-input
                id="rfc"
                v-model="customerData.rfc"
                :state="getValidationState(validationContext)"
                trim
                onkeyup="this.value = this.value.toUpperCase();"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Domicilio -->
          <validation-provider
            #default="validationContext"
            :name="$t('AppCustomer.columns.address')"
            rules="required|max:250"
          >
            <b-form-group
              :label="$t('AppCustomer.columns.address')"
              label-for="domicilio"
            >
              <b-form-input
                id="domicilio"
                v-model="customerData.domicilio"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ $t('Lists.Add') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              {{ $t('Lists.Cancel') }}
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import {
  required, alphaNum, email, min, max,
} from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import customerService from '@/services/customer.service'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewCustomerSidebarActive',
    event: 'update:is-add-new-Customer-sidebar-active',
  },
  props: {
    isAddNewCustomerSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      min,
      max,
    }
  },
  setup(props, { emit }) {
    /* Services */
    const {
      createCustomer,
    } = customerService()
    const blankCustomerData = {
      alias: '',
      nombre: '',
      rfc: '',
      domicilio: null,
    }

    const customerData = ref(JSON.parse(JSON.stringify(blankCustomerData)))

    const resetcustomerData = () => {
      customerData.value = JSON.parse(JSON.stringify(blankCustomerData))
    }

    const onSubmit = () => {
      createCustomer(customerData.value)
        .then(() => {
          emit('update:is-add-new-customer-sidebar-active', false)
          emit('refetch-data')
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetcustomerData)

    return {
      customerData,
      onSubmit,

      createCustomer,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-customer-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
